import { render, staticRenderFns } from "./RegisterScreen.vue?vue&type=template&id=0326f688&"
import script from "./RegisterScreen.vue?vue&type=script&lang=js&"
export * from "./RegisterScreen.vue?vue&type=script&lang=js&"
import style0 from "./RegisterScreen.vue?vue&type=style&index=0&id=0326f688&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports